import { Inter } from "next/font/google";
import classNames from "classnames";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

export const TopPlaceDescription = ({ description }) => {
    if (!description && process.env.NODE_ENV === "production") {
        console.log("No description");
        return null;
    }

    return (
        <p
            id="top-place-description"
            onClick={() => trackItemTapped(MixpanelValues.ItemTapped.BLURB)}
            className={classNames(
                inter.className,
                "text-sky-950 text-[15px] font-medium leading-[150%] mb-4"
            )}>
            {description || (
                process.env.NODE_ENV === "development"
                    ? "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
                    : ""
            )}
        </p>
    );
};
